module.exports = __webpack_public_path__ + "img/sock.80731b74.png";